/** The market colour for a sign (`sign()` of a move): up, down, or flat. */
export const directionTone = (direction: number): string =>
  direction > 0 ? 'text-market-up' : direction < 0 ? 'text-market-down' : 'text-market-flat'
